import PieBase from './PieBase';

const ENGLISH = 'English';

const LanguageChart = ({ chartData }) => {
  const data = [];
  const languageCounts = {};

  for (const alertElement of chartData) {
    const { preferredLanguage: language } = alertElement;
    if (language && language !== ENGLISH) {
      if (!(language in languageCounts)) {
        languageCounts[language] = {
          label: language,
          value: 1,
        };
      } else {
        languageCounts[language].value += 1;
      }
    }
  }

  for (const language of Object.values(languageCounts)) {
    data.push(language);
  }

  return (
    <PieBase
      title={'Languages'}
      data={data}
    />
  );
};

export default LanguageChart;
